import { HTMLAttributes } from 'react';

import styles from './styles.module.scss';

interface Props extends HTMLAttributes<HTMLSpanElement> {
    variant?: 'primary' | 'outline' | 'outline-small' | 'dot'
    color?: string;
    textColor?: string;
}

function Badge(props: Props) {
    const {
        className,
        variant = 'primary',
        textColor = 'white',
        color = 'var(--color-primary)',
        style,
        ...rest
    } = props;
    const isOutline = (variant === 'outline' || variant === 'outline-small');
    const badgeStyle = {
        color: isOutline ? color : textColor,
        backgroundColor: isOutline ? 'transparent' : color,
        borderColor: isOutline ? color : 'transparent',
    };
    return <span aria-label='badge'
        className={`${styles.badge} ${styles[`badge-${variant}`]} ${className}`}
        style={{ ...badgeStyle, ...style }}
        {...rest}
    />;
}

export default Badge;
